import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { RolesValidator } from '../../../../validations/RolesValidator';
import { ROLE } from '../../../../utils/ROLE';
import { MealTable } from './MealTable';
import { MenuTodayActions } from './MenuTodayActions';
import { getDeclarationStatus, getTodayMenu } from './MenuTodayService';
import { Tab, Tabs } from 'react-bootstrap';

const MenuTodayPage = () => {
    const { t } = useTranslation('monthMenu');
    const alert = useAlert();
    const isDietist = RolesValidator([ROLE.DIETIST]);
    const [menu, setMenu] = useState({ dayNumber: 0, breakfast: [], lunch: [], diner: [], snack: [] });
    const [isPeopleDeclared, setIsPeopleDeclared] = useState(false);


    useEffect(() => {
        getTodayMenu()
            .then((response) => {
                if (response.data != null) {
                    setMenu(response.data);
                }
            })
            .catch(() => alert.error(t('alert:loadingError')));
        const timer = setInterval(peopleDeclared, 1000);
        return () => onDestroy(timer);
    }, [isPeopleDeclared]);

    const peopleDeclared = () => {
        if (!isPeopleDeclared) {
            getDeclarationStatus()
                .then((response) => {
                    setIsPeopleDeclared(response.data);
                })
                .catch(() => {
                    setIsPeopleDeclared(false);
                });
        }
    };

    const onDestroy = (timer) => {
        clearInterval(timer);
    };

    return (
        <>
            {isDietist ? <MenuTodayActions /> : <></>}
            <h3 className={'center'}>{menu.dayNumber} {t('monthMenu:dayNumber')}</h3>
            <div className={'bdsm-selection-tabs--wrapper'}>
                <Tabs
                    id='menu-today-tabs'
                    className='bdsm-selection-tabs'
                    mountOnEnter={true}
                    fill>
                    <Tab eventKey='breakfast' title={t('todayMenu:breakfast')}>
                        <MealTable meal={menu['breakfast']} isPeopleDeclared={isPeopleDeclared}></MealTable>
                    </Tab>
                    <Tab eventKey='lunch' title={t('todayMenu:lunch')}>
                        <MealTable meal={menu['lunch']} isPeopleDeclared={isPeopleDeclared}></MealTable>
                    </Tab>
                    <Tab eventKey='diner' title={t('todayMenu:diner')}>
                        <MealTable meal={menu['diner']} isPeopleDeclared={isPeopleDeclared}></MealTable>
                    </Tab>
                    <Tab eventKey='snack' title={t('todayMenu:snack')}>
                        <MealTable meal={menu['snack']} isPeopleDeclared={isPeopleDeclared}></MealTable>
                    </Tab>
                </Tabs>
            </div>
        </>
    );

};
export default MenuTodayPage;
